import React from "react";
import { Box } from "@mui/material";
import { List, ListItem, ListItemText } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function Drawer() {
  const { pathname } = useLocation();

  const { user } = useSelector((state) => state.user);

  // console.log("role-------", user.role);

  return (
    <Box component="aside" className="app__drawer">
      <Box className="logo">
        <img src="/images/logo.png" alt="" />
      </Box>
      <Box>
        <List>
          {user.role === "DSA" || user.role === "Field-Agent" ? (
            <>
              <ListItem className={pathname === "/" ? "active" : ""}>
                <Link to="/">
                  <ListItemText primary="Home" />
                </Link>
              </ListItem>
              <ListItem className={pathname === "/lead-report" ? "active" : ""}>
                <Link to="/lead-report">
                  <ListItemText primary={user.role === "Field-Agent" ? "Merchant List" : "Lead Report"} />
                </Link>
              </ListItem>
              <ListItem className={pathname === "/commission" ? "active" : ""}>
                <Link to="/commission">
                  <ListItemText primary="Commission" />
                </Link>
              </ListItem>
            </>
          ) : (
            <>
              <ListItem className={pathname === "/" ? "active" : ""}>
                <Link to="/">
                  <ListItemText primary="Direct Selling Agent" />
                </Link>
              </ListItem>
              <ListItem className={pathname === "/field-agents" ? "active" : ""}>
                <Link to="/field-agents">
                  <ListItemText primary="Field Agent" />
                </Link>
              </ListItem>
            </>
          )}
        </List>
      </Box>
    </Box>
  );
}
